var app = angular.module('leonardo');

var UnitsImportStates = function ($stateProvider) {
  $stateProvider.state('admin-utilities', {
    url: '/admin-utilities',
    parent: 'authenticated.layout-main',
    views: {
      user: {
        templateUrl: 'views/templates/user/logged.html',
        controller: 'UserMenu'
      }
    },
    redirectTo: 'admin-utilities.units-import',
    ncyBreadcrumb: {
      skip: true
    }
  });

  $stateProvider.state('admin-utilities.merge-units', {
    url: '/merge-units?account&portfolio&group&property&search',
    views: {
      'breadcrumb@authenticated.layout-main': {
        template: ' '
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/admin/utilities/merge-units.html',
        controller: 'MergeUnitsController'
      }
    },
    ncyBreadcrumb: {
      label: 'Merge Units'
    }
  });

  $stateProvider.state('admin-utilities.merge-units.detail', {
    url: '/:id?account&portfolio&group&property&search',
    views: {
      'breadcrumb@authenticated.layout-main': {
        template: ' '
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/admin/utilities/merge-units.html',
        controller: 'MergeUnitsDetailsController'
      }
    },
    ncyBreadcrumb: {
      skip: true
    }
  });

  $stateProvider.state('admin-utilities.dynamic-form-finder', {
    url: '/dynamic-form-finder',
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/admin/utilities/dynamic-finder.html',
        controller: 'DynamicFinderController'
      }
    },
    ncyBreadcrumb: {
      label: 'Dynamic Form Response Finder'
    }
  });

  $stateProvider.state('admin-utilities.properties-import', {
    url: '/properties-import',
    entity: 'property',
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/admin/utilities/import.html',
        controller: 'UtilityImportController'
      }
    },
    ncyBreadcrumb: {
      label: 'Properties Import'
    }
  });

  $stateProvider.state('admin-utilities.properties-export', {
    url: '/properties-export',
    entity: 'property',
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/admin/utilities/export.html',
        controller: 'UtilityImportController'
      }
    },
    ncyBreadcrumb: {
      label: 'Properties Export'
    }
  });

  $stateProvider.state('admin-utilities.properties-amenities-import', {
    url: '/properties-amenities-import',
    entity: 'property-amenity',
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/admin/utilities/import.html',
        controller: 'UtilityImportController'
      }
    },
    ncyBreadcrumb: {
      label: 'Properties Amenities Import'
    }
  });
  $stateProvider.state('admin-utilities.properties-amenities-export', {
    url: '/properties-amenities-export',
    entity: 'property-amenity',
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/admin/utilities/export.html',
        controller: 'UtilityImportController'
      }
    },
    ncyBreadcrumb: {
      label: 'Properties Amenities Export'
    }
  });

  $stateProvider.state('admin-utilities.users-import', {
    url: '/users-import',
    entity: 'user',
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/admin/utilities/import.html',
        controller: 'UtilityImportController'
      }
    },
    ncyBreadcrumb: {
      label: 'Users Import'
    }
  });

  $stateProvider.state('admin-utilities.users-export', {
    url: '/users-export',
    entity: 'user',
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/admin/utilities/export.html',
        controller: 'UtilityImportController'
      }
    },
    ncyBreadcrumb: {
      label: 'Users Export'
    }
  });

  $stateProvider.state('admin-utilities.units-import', {
    url: '/units-import',
    entity: 'unit',
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/admin/utilities/import.html',
        controller: 'UtilityImportController'
      }
    },
    ncyBreadcrumb: {
      label: 'Units Import'
    }
  });

  $stateProvider.state('admin-utilities.units-export', {
    url: '/units-export',
    entity: 'unit',
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/admin/utilities/export.html',
        controller: 'UtilityImportController'
      }
    },
    ncyBreadcrumb: {
      label: 'Units Export'
    }
  });

  $stateProvider.state('admin-utilities.undelete-units', {
    url: '/undelete-units',
    unitDelete: false,
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/unit/list.html',
        controller: 'UnitList'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'UnitFilters'
      },
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/delete-units.html',
        controller: 'DeleteUnitsController'
      }
    },
    ncyBreadcrumb: {
      label: 'Undelete Units'
    }
  });

  $stateProvider.state('admin-utilities.delete-units', {
    url: '/delete-units',
    unitDelete: true,
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/unit/list.html',
        controller: 'UnitList'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'UnitFilters'
      },
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/delete-units.html',
        controller: 'DeleteUnitsController'
      }
    },
    ncyBreadcrumb: {
      label: 'Delete Units'
    }
  });

  $stateProvider.state('admin-utilities.delete-tasks', {
    url: '/delete-tasks',
    views: {
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'DeleteTasksFilters'
      },
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/delete-tasks.html',
        controller: 'DeleteTasksActions'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/task/delete-tasks.html',
        controller: 'DeleteTasksList'
      }
    },
    ncyBreadcrumb: {
      label: 'Delete Past Due'
    }
  });

  $stateProvider.state('admin-utilities.delete-workflow', {
    url: '/delete-workflow',
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/workflow/instances-list.html',
        controller: 'WorkFlowInstanceDeleteList'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'WorkFlowInstanceDeleteFilters'
      },
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/delete-workflow.html',
        controller: 'WorkFlowInstanceDeleteController'
      }
    },
    ncyBreadcrumb: {
      label: 'Delete Workflow Instances'
    }
  });
};

app.config(['$stateProvider', UnitsImportStates]);
